import { render, staticRenderFns } from "./commandeclient_edit.vue?vue&type=template&id=45de9107&scoped=true&"
import script from "./commandeclient_edit.vue?vue&type=script&lang=js&"
export * from "./commandeclient_edit.vue?vue&type=script&lang=js&"
import style0 from "./commandeclient_edit.vue?vue&type=style&index=0&id=45de9107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de9107",
  null
  
)

export default component.exports